// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.75 8.75L2.5 5.5L5.75 2.25M2.5 5.5H9.75C11.96 5.5 13.75 7.29 13.75 9.5C13.75 11.71 11.96 13.5 9.75 13.5H7.75',
];
